/* First Light Astronomy — Process Orbit
   Interactive 7-step orbit with center-disc swap, panel reveal,
   keyboard navigation (Enter/Space/Escape), and aria-pressed sync. */
(function () {
  function splitTitle(t) {
    var w = t.split(' '), a = t, b = '';
    for (var j = w.length - 1; j > 0; j--) {
      var s = w.slice(0, j).join(' ');
      if (s.length <= 16) { a = s; b = w.slice(j).join(' '); break; }
    }
    return [a, b];
  }

  function init(root) {
    if (!root || root.dataset.flaOrbitReady === '1') return;
    root.dataset.flaOrbitReady = '1';

    var steps;
    try {
      steps = JSON.parse(root.querySelector('[data-fla-orbit-data]').textContent);
    } catch (_) { return; }
    if (!steps || !steps.length) return;

    var dg = root.querySelector('[data-orbit-default]');
    var ag = root.querySelector('[data-orbit-active]');
    var en = root.querySelector('[data-orbit-num]');
    var ep = root.querySelector('[data-orbit-phase]');
    var e1 = root.querySelector('[data-orbit-t1]');
    var e2 = root.querySelector('[data-orbit-t2]');
    var pn = root.querySelector('[data-orbit-panel]');
    var nodes = root.querySelectorAll('[data-orbit-step]');
    var labels = root.querySelectorAll('[data-orbit-label]');
    var act = null;

    function show(i) {
      if (act === i) { reset(); return; }
      act = i;
      var s = steps[i];
      if (!s) return;
      var tl = splitTitle(s.ti);
      if (en) { en.textContent = s.n; en.setAttribute('fill', s.co); }
      if (ep) ep.textContent = (s.ph || '').toUpperCase();
      if (e1) e1.textContent = tl[0];
      if (e2) e2.textContent = tl[1];
      if (dg) dg.style.opacity = '0';
      if (ag) ag.style.opacity = '1';
      if (pn) {
        pn.innerHTML =
          '<span class="op-n" style="color:' + s.co + '">' + s.n + '</span>' +
          ' <span class="op-ph">' + s.ph + '</span>' +
          '<h3 class="op-ti">' + s.ti + '</h3>' +
          '<p class="op-ds">' + s.ds + '</p>';
        pn.style.opacity = '1';
        pn.style.transform = 'translateY(0)';
      }
      nodes.forEach(function (el) {
        el.style.opacity = (+el.dataset.orbitStep === i) ? '1' : '0.28';
        el.setAttribute('aria-pressed', (+el.dataset.orbitStep === i) ? 'true' : 'false');
      });
      labels.forEach(function (el) {
        el.style.opacity = (+el.dataset.orbitLabel === i) ? '1' : '0.28';
      });
    }
    function reset() {
      act = null;
      if (dg) dg.style.opacity = '1';
      if (ag) ag.style.opacity = '0';
      if (pn) { pn.style.opacity = '0'; pn.style.transform = 'translateY(6px)'; }
      nodes.forEach(function (el) {
        el.style.opacity = '1';
        el.setAttribute('aria-pressed', 'false');
      });
      labels.forEach(function (el) { el.style.opacity = '1'; });
    }

    nodes.forEach(function (el) {
      el.addEventListener('click', function () { show(+el.dataset.orbitStep); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          show(+el.dataset.orbitStep);
        }
      });
    });
    labels.forEach(function (el) {
      el.addEventListener('click', function () { show(+el.dataset.orbitLabel); });
    });
    if (dg) dg.addEventListener('click', reset);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && act !== null) reset();
    });
  }

  function bootAll() { document.querySelectorAll('[data-fla-orbit]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else { bootAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector('[data-fla-orbit]') || (e.target.matches && e.target.matches('[data-fla-orbit]') ? e.target : null);
    if (node) init(node);
  });
})();
